import UISignals from "@baseUI/controllers/UISignals";
import UIBaseContainer from "@baseUI/component/base/UIBaseContainer";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import AutoplayCounter from "@baseUI/component/specials/AutoplayStopCounter";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import UICreatorText from "@baseUI/utils/UICreatorText";
import UIFacade from "@baseUI/UIFacade";

export default class UIBaseView extends UIBaseContainer {

    constructor(uiModelView) {
        super()
        this.uiModelView = uiModelView
        this.setParametersSizePosition()
        this.init()
        this.hide()
    }

    setParametersSizePosition() {
        this.nameLayout = 'Layout'

        this.param = {
            widthPanel: this.uiModelView.widthScreen,   //1120,            //this.uiModelView.width + 100
            panelButtonsPosition: {x: 0, y: 2500},
            spinBtn: {name: 'mobileSpinPortrait_BUTTON', position: [0, 100]},
            maxBetBtn: {name: 'mobileBet_BUTTON', position: [250, 100]},
            autoplayBtn: {name: 'mobileAutoplayPortrait_BUTTON', position: [-250, 100]},
            autoplayCounterBtnPosition: {name: 'mobileAutoplayStop_BUTTON', position: [-250, 100]},
            yPanelBottom: 2000,
            isBottomWatch: true,
            infoBtn: {name: 'info_BUTTON'},
            menuBtn: {name: 'menu_BUTTON'},
            soundBtn: {name: 'sound_STATE'}
        }
    }

    init() {
        const widthPanel = this.param.widthPanel

        this.createPanelTop(widthPanel)
        this.createPanelBottom(widthPanel)
        this.createButtons()
        // UISignals.setStateUIButtons.add(this.onStateUIButtons, this)
        UISignals.setStateUIPanels.add(this.onStateUIPanels, this)
       // UISignals.resize.add(this.onResize, this)
    }

    onStateUIButtons(data) {
        const check = (obj, name, bnt) => {
            if (obj[name]) {
                if (obj[name].visible !== undefined) {
                    obj[name].visible ? bnt.show() : bnt.hide()
                }
            }
            if (obj[name]) {
                if (obj[name].enable !== undefined) {
                    bnt.enable = obj[name].enable
                }
            }
        }

        check(data, 'spin', this.spinBtn)
        check(data, 'autoplay', this.autoplayBtn)
        check(data, 'maxBet', this.maxBetBtn)
        check(data, 'autoplayCounter', this.autoplayCounterBtn)
    }

    onStateUIPanels(data) {
        const check = (obj, name, panel) => {
            if (obj[name]) {
                if (obj[name].visible !== undefined) {
                    panel.visible = obj[name].visible
                }
                if (obj[name].enable !== undefined) {
                    panel.enable = obj[name].enable
                }
            }
        }
        check(data, 'panelFS', this.panelFS)
        check(data, 'panelBase', this.panelButtons)
        // TODO: The whole panel enabling/disabling
        check(data, 'activeBets', this.activeBets)
    }

    createPanelTop(widthPanel) {
        const panelTop = UICreatorComponent.addContainer(this, {x: 0, y: 200})
        this.panelTop = panelTop
    }

    createButtons() {
        const panelButtons = UICreatorComponent.addContainer(this, this.param.panelButtonsPosition)// this.uiModelView.height - 165 })

        this.spinBtn = UICreatorComponent.addButton(this.param.spinBtn.name, panelButtons, this.param.spinBtn.position)
        this.spinBtn.on('tapButton', () => {
            // TODO: change
            console.log('spin')
            document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'spin'}}))
        })
        this.maxBetBtn = UICreatorComponent.addButton(this.param.maxBetBtn.name, panelButtons, this.param.maxBetBtn.position)
        this.maxBetBtn.on('tapButton', () => {
            UISignals.setStateMenu.dispatch("menuBet")
        })
        this.autoplayBtn = UICreatorComponent.addButton(this.param.autoplayBtn.name, panelButtons, this.param.autoplayBtn.position)
        this.autoplayBtn.on('tapButton', () => {
            UISignals.setStateMenu.dispatch("menuAutoplay")
        })

        this.autoplayBtn.unvisible = !UIFacade.model.isAutospinShow
        UIFacade.model.isAutospinShow ? this.autoplayBtn.show() : this.autoplayBtn.hide()

        this.autoplayCounterBtn = new AutoplayCounter(this.param.autoplayCounterBtnPosition.name)
        this.autoplayCounterBtn.x = this.param.autoplayCounterBtnPosition.position[0]
        this.autoplayCounterBtn.y = this.param.autoplayCounterBtnPosition.position[1]
        panelButtons.addChild(this.autoplayCounterBtn)
        this.autoplayCounterBtn.hide()
        UISignals.stopAutoplay.add(this.setAutoplayStop, this)

        this.panelButtons = panelButtons
        UISignals.setAutoplayStart.add(this.setAutoplayStart.bind(this))
    }

    setButtonState(date) {

        for (let [key, value] of Object.entries(date)) {

            key += 'Btn'
            if (!this[key]){
                console.log('  Not exists! ',key, value)
            }
            else{
                if (value.hasOwnProperty('enable')) {
                    if (value.enable) {
                        this[key].enable()
                    } else {
                        this[key].disable()
                    }
                }

                if (value.hasOwnProperty('visible')) {
                    if (value.visible) {
                        this[key].show()
                    } else {
                        this[key].hide()
                    }
                }
            }

            if (value.hasOwnProperty('checked')) {
                UISignals.setState.dispatch(key, value.checked)
            }
        }
    }

    setAutoplayStop(){
        this.autoplayBtn.show()
        this.autoplayCounterBtn.hide()
    }

    setAutoplayStart(count){
        this.autoplayBtn.hide()
        this.autoplayCounterBtn.show()
        if (count === -1){
            this.autoplayCounterBtn.betSliderVisible = false
        }else{
            this.autoplayCounterBtn.betSliderVisible = true
            this.autoplayCounterBtn.count = count
        }
    }

    addSubstrateComponent(widthPanel, rectWidth){
        const xStart = -widthPanel / 2 - 50
        this.panelSubstrate.removeChildren()
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, rectWidth + 3, widthPanel + 100, 2 * rectWidth + 3, 0x323031, 0.7)
        UICreatorGraphics.addLine(this.panelSubstrate, xStart, 2 * rectWidth + 3, widthPanel/2 + 50, 2 * rectWidth + 3)
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, 2 * rectWidth + 7, widthPanel + 100, 1000, 0x323031, 0.9)
    }

    addFreespinsComponent(widthPanel, rectWidth){
        this.panelFS = UICreatorComponent.addContainer(this.panelBottom, {x: 0, y: rectWidth})
        this.panelFS.interactive = false
        this.panelFS.visible = false
        this.fsText = UICreatorText.addElementDynamicTextName('fS_DYNAMIC', this.panelFS, [50, 50])
        this.showFreeSpinsLeft(UIFacade.model.amountLeft)
        UISignals.setFreeSpinLeft.add((value) => {
            this.showFreeSpinsLeft(value)
        })
    }

    showFreeSpinsLeft(value){
        let text = UIFacade.textFactory.getLocalizedText('fsFreespinsCaption_TEXT')
        let count = /<count>/gi
        let total = /<total>/gi
        const totalCount = UIFacade.model.freeSpinTotalCount
        text = text.replace(count, totalCount - value).replace(total, totalCount)
        this.fsText.visible = totalCount - value > 0
        this.fsText.text = text
    }

    addValueAndTextComponents() {
        const panelBottom = this.panelBottom
        this.activeBets = UICreatorComponent.addActiveBets(panelBottom, [0, 0])
        this.plusBtn = this.activeBets.plusButton
        this.minusBtn = this.activeBets.minusButton

        this.winText = UICreatorText.addElementTextName('mobileWin_TEXT', panelBottom, [0, 0])
        this.winValue = UICreatorText.addElementDynamicTextName('win_DYNAMIC', panelBottom, [this.winText.x, this.winText.y + 60])
        UISignals.setWinUI.add((value) => {
            this.winValue.text = ( value === '' ) ? 0 : value
        })

        this.balanceText = UICreatorText.addElementTextName('mobileBalance_TEXT', panelBottom, [-400, 260])
        this.balanceValue = UICreatorText.addElementDynamicTextName('balance_DYNAMIC', panelBottom, [this.balanceText.x + this.balanceText.width / 2 + 20, this.balanceText.y])
        UISignals.setBalance.add((value) => {
            this.balanceValue.text = ( value === '' ) ? 0 : value
        })

        this.soundBtn = UICreatorComponent.addListenerStateButton(this.param.soundBtn.name, 'sound_music', panelBottom, [220, 260])
        this.infoBtn = UICreatorComponent.addButton(this.param.infoBtn.name, panelBottom, [120, 260])
        this.infoBtn.on('tapButton', () => {
            UISignals.setStateMenu.dispatch("menuInfo")
        })
        this.menuBtn = UICreatorComponent.addButton(this.param.menuBtn.name, panelBottom, [30, 260])
        this.menuBtn.on('tapButton', () => {
            UISignals.setStateMenu.dispatch("menuSettings")
        })
    }

    addGameNameWatchRTP(panel){
        this.gameNameText = UICreatorText.addSimpleTextComponent('gameName_TEXT', 'systemTopText', panel, [ -350, 260])
        this.watchText = UICreatorComponent.addWatches('watch', panel, [-100, 260])

        const rtpText = `MAX WIN: ${UIFacade.model.maxwin}   RTP: ${UIFacade.model._rtp}`
        this.rtpText = UICreatorText.addElementTextSimple(rtpText, "systemTopText", panel, [0, 260])
        this.rtpText.visible = (UIFacade.model.maxwin && UIFacade.model._rtp)
    }

    setPositionComponents(widthPanel, rectWidth){
        this.activeBets.position.set( -widthPanel/2, rectWidth + 5)
        this.winText.position.set(600, rectWidth + 20)
        this.winValue.position.set(this.winText.x, this.winText.y + 60)
        this.balanceText.position.set(-400, 260)
        this.balanceValue.position.set(this.balanceText.x + this.balanceText.width/2 + 20, this.balanceText.y)
        this.soundBtn.position.set(-widthPanel/2 + 220, 260)
        this.infoBtn.position.set(-widthPanel/2 + 120, 260)
        this.menuBtn.position.set(-widthPanel/2 + 30, 260)

        this.gameNameText.position.set(widthPanel / 2 - 350, 260)
        this.watchText.position.set(widthPanel / 2 - 100, 260)
        this.rtpText.position.set(0, 260)

    }

    createPanelBottom(widthPanel) {

        this.panelBottom = UICreatorComponent.addContainer(this, {x: 0, y: this.param.yPanelBottom})
        this.panelBottom.interactive = false
        this.panelSubstrate = UICreatorComponent.addContainer(this.panelBottom, {x: 0, y: 0})
        this.panelSubstrate.interactive = false

        const rectWidth = 110
        this.addSubstrateComponent(widthPanel, rectWidth)
        this.addFreespinsComponent(widthPanel, rectWidth)
        this.addValueAndTextComponents()
        if (this.param.isBottomWatch){
            this.addGameNameWatchRTP(this.panelBottom )
        }
        this.setPositionComponents(widthPanel, rectWidth)
    }

    update() {
        console.log('update')
        this.menuPopup.updateSize(this.uiModelView)
    }

    onResize(){
        this.update()
    }

    updateText(){
        this.menuPopup.updateText()
    }
}
